import { FsCore } from '../../types/fs-core'

const getComponentsState = (s: FsCore.State) => s.components

export const getComponentById = (s: FsCore.State, id: string) => getComponentsState(s)[id]
